import { cn } from 'utils/analytics/cn'

type TokenTableKind = 'pools' | 'transactions'

const VIEWS = ['pools', 'transactions'] as const

type ToggleControlProps = {
  title: string
  checked: boolean
  onToggle: () => void
  disabled?: boolean
}

const ToggleControl = ({ title, checked, onToggle, disabled }: ToggleControlProps) => {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={() => !disabled && onToggle()}
      disabled={disabled}
      className={cn(
        'flex items-center gap-3 px-3 py-2 rounded-md border text-xs font-medium transition-colors cursor-pointer whitespace-nowrap capitalize',
        'border-kodiak-border-primary hover:border-kodiak-border-secondary',
        disabled && 'opacity-50 cursor-not-allowed'
      )}
    >
      <span>{title}</span>
      <span className="w-5 h-5 rounded-sm flex items-center justify-center text-xs border-2 border-kodiak-border-primary">
        {checked ? '✓' : ''}
      </span>
    </button>
  )
}

type TableManageBarProps = {
  view: TokenTableKind
  onViewChange: (view: TokenTableKind) => void
  hideLowTvl: {
    value: boolean
    onChange: (value: boolean) => void
  }
  hideLowVolume: {
    value: boolean
    onChange: (value: boolean) => void
  }
}

export default function TableManageBar({ view, onViewChange, hideLowTvl, hideLowVolume }: TableManageBarProps) {
  const showFilters = view === 'pools'

  return (
    <div className="flex flex-col gap-4 w-full">
      <div className="flex flex-wrap gap-3 items-center justify-between">
        <div className="flex gap-2 items-center">
          {VIEWS.map((v) => (
            <button
              key={v}
              type="button"
              onClick={() => onViewChange(v)}
              className={cn(
                'px-3 py-2 font-medium transition-colors cursor-pointer capitalize',
                view === v ? 'text-kodiak-text-primary' : 'text-kodiak-button-disabled'
              )}
              aria-pressed={view === v}
            >
              {v}
            </button>
          ))}
        </div>

        {showFilters && (
          <div className="flex gap-2">
            <ToggleControl
              title="Hide low volume"
              checked={hideLowVolume.value}
              onToggle={() => hideLowVolume.onChange(!hideLowVolume.value)}
            />
            <ToggleControl
              title="Hide low tvl"
              checked={hideLowTvl.value}
              onToggle={() => hideLowTvl.onChange(!hideLowTvl.value)}
            />
          </div>
        )}
      </div>
    </div>
  )
}
